import React from 'react';
import type { ComponentProps, CSSProperties, ReactElement } from 'react';

import { orderedListSelector } from '@atlaskit/adf-schema/ordered-list';
import { getItemCounterDigitsSize, resolveOrder } from '@atlaskit/editor-common/utils/list';
import type { OrderedList as OriginalOrderedList } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

export const OrderedList = (
	props: ComponentProps<typeof OriginalOrderedList> & LightNodeProps,
): ReactElement => {
	const digits = getItemCounterDigitsSize({
		order: props.order,
		itemsCount: props.getContent?.()?.length,
	});
	// Match Platform's digit-based marker gutter without importing its style object.
	const style: CSSProperties & { '--ed--list--item-counter--padding'?: string } =
		digits && digits > 1
			? { '--ed--list--item-counter--padding': `calc(${digits + 1}ch - 2px)` }
			: {};
	const indentLevel =
		1 +
		(props.path?.filter(
			(node) => node.type.name === 'bulletList' || node.type.name === 'orderedList',
		).length ?? 0);
	return (
		<ol
			ref={props.lightNodeRef}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Preserve Platform list styling and nested marker selectors.
			className={orderedListSelector.slice(1)}
			data-local-id={props.localId}
			data-indent-level={indentLevel}
			start={props.order !== undefined ? resolveOrder(props.order) : props.start}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Authored numbering and item count determine the marker gutter at runtime.
			style={style}
		>
			{props.children}
		</ol>
	);
};
